import api from '../api';

import { ParamsDataGetPlatformRemoval } from 'utils/typeServices';

export const GetPlatformRemoval = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<Array<ParamsDataGetPlatformRemoval>>('v1/Plataforma/GetPlatformRemoval', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
